import { lazy } from 'react';

export const EventSeriesPage = lazy(() => import('./controller.js'));
